import React from "react";
import { Check } from "lucide-react";
import { BENEFITS } from "../mock";
import { useJobModal } from "../context/JobModalContext";

export default function Benefits() {
  const { openJobModal } = useJobModal();
  return (
    <section id="caregivers" className="bg-white">
      <div className="max-w-7xl mx-auto px-5 py-16">
        <div className="rounded-3xl bg-[#fbf3f0] border border-[#7c2233]/10 p-8 sm:p-12 max-w-4xl mx-auto">
          <span className="inline-block text-[13px] font-medium text-[#7c2233] bg-white rounded-full px-3 py-1 border border-[#7c2233]/15">Transparent & vetted</span>
          <h2 className="font-display text-3xl sm:text-4xl text-[#1f1a1b] mt-4">Your benefits</h2>
          <p className="text-[16px] text-[#5a5254] mt-4 leading-relaxed">
            We pre-select in advance – no more scrolling and searching through 1,000 profiles. At SimplySitter, only experienced, carefully vetted caregivers apply to your job. Finding care has never been this easy and safe.
          </p>
          <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-3 mt-6">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-start gap-2.5 text-[15px] text-[#3a3436]">
                <span className="mt-0.5 w-5 h-5 rounded-full bg-[#7c2233] flex items-center justify-center shrink-0">
                  <Check className="w-3 h-3 text-white" strokeWidth={3} />
                </span>
                {b}
              </li>
            ))}
          </ul>
          <a href="#post" onClick={(e) => { e.preventDefault(); openJobModal({}); }} className="inline-flex mt-8 items-center justify-center rounded-xl bg-[#7c2233] hover:bg-[#661b29] text-white font-medium px-7 py-3.5 shadow-sm transition-colors">
            Post a job free
          </a>
        </div>
      </div>
    </section>
  );
}
